import { useLocation, useParams } from "../../../../router-utils"
import { WhatsAppInboxThread } from "../../../../WhatsAppMessages"

type TOpenState = {
	openBoundary?: number | null
	openUnread?: number
}

export default function WhatsAppInboxThreadPage() {
	const { threadId } = useParams("/whatsapp/inbox/:threadId")
	// The list passes the open-time read pointer + unread count via navigation
	// state so the unread divider is correct even when the detail's cache is stale.
	const state = (useLocation().state as TOpenState | null) ?? {}
	return (
		<WhatsAppInboxThread
			key={threadId}
			threadId={Number(threadId)}
			openBoundary={state.openBoundary}
			openUnread={state.openUnread}
		/>
	)
}
